import React, { useEffect, useState } from 'react';
import { WifiOff, Loader2 } from 'lucide-react';

// „Kapcsolat helyreállítása…” sáv: amíg az interceptor újrapróbál, hiba helyett ezt látja a felhasználó
export default function ConnectionBanner() {
  const [degraded, setDegraded] = useState(false);
  useEffect(() => {
    const h = (e) => setDegraded(!!e.detail?.degraded);
    window.addEventListener('acx-connection', h);
    return () => window.removeEventListener('acx-connection', h);
  }, []);
  if (!degraded) return null;
  return (
    <div data-testid="connection-banner" className="fixed top-0 left-0 right-0 z-[10050] flex items-center justify-center gap-2 px-4 py-1.5 text-xs font-medium text-white shadow-md"
      style={{ background: '#B85A26' }}>
      <WifiOff size={13} /> Kapcsolat helyreállítása a szerverrel… <Loader2 size={13} className="animate-spin" /> újrapróbálkozás folyamatban
    </div>
  );
}
